import { Injectable } from '@angular/core';
import { BaseClientService } from '../../../core/services/base-client.service';
import { HttpClient } from '@angular/common/http';
import { SelectModel } from '../../../core/models/select.mode';
import { ProjectModel } from '../models/project.model';

@Injectable({
  providedIn: 'root'
})
export class ProjectsService extends BaseClientService<ProjectModel> {

  constructor(httpClient: HttpClient) {
    super('projects', httpClient);
  }

  getProjects(projects: ProjectModel[], isRtl: boolean): SelectModel[] {
    return projects?.map(projects => ({
      key: projects.id,
      name: isRtl ? projects.nameAr : projects.name
    }));
  }

}
